import React from "react";
import Icon, { type IconProps } from "./Icon";

/**
 * AlertCircle icon — vendored from Lucide.
 * Source: https://lucide.dev/icons/alert-circle (MIT). Copied 2026-05-16.
 *
 * Phase 2c: replaces Banner's `✕` Unicode for tone="danger". The `!` in a
 * circle reads "alert/error" — visually distinct from CheckCircle2 (success)
 * and Info (info).
 */
export default function AlertCircle(props: Omit<IconProps, "children">) {
  return (
    <Icon {...props}>
      <circle cx="12" cy="12" r="10" />
      <line x1="12" x2="12" y1="8" y2="12" />
      <line x1="12" x2="12.01" y1="16" y2="16" />
    </Icon>
  );
}
